import { render, staticRenderFns } from "./TopControls.vue?vue&type=template&id=03143ed8&scoped=true"
import script from "./TopControls.vue?vue&type=script&lang=ts"
export * from "./TopControls.vue?vue&type=script&lang=ts"
import style0 from "./TopControls.vue?vue&type=style&index=0&id=03143ed8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03143ed8",
  null
  
)

export default component.exports